import type { CpAccordionItem } from "../../components/CpAccordion/CpAccordion";

export const SOAR_CTA_HREF = "https://info.mycertainpath.com/soar";

export const TIERS = ["Build", "Grow", "Lead", "Scale"];

export const TARGETS = [
  { v: "20%+", l: "More revenue" },
  { v: "5–10%", l: "More profit on the bottom line" },
  { v: "5–10%", l: "Higher call booking rate" },
  { v: "2–3%", l: "Added back from material management" },
];

export const REVIEWS = [
  {
    icon: "network",
    title: "Org Chart Review",
    body: "Are you overstaffed in one department and understaffed in another?",
  },
  {
    icon: "chart-line",
    title: "P&L / 7-Year Trend Review",
    body: "Find where you're losing money and don't realize it.",
  },
  {
    icon: "clipboard-list",
    title: "DMER Review",
    body: "Identify little problems today before they become larger problems tomorrow.",
  },
  {
    icon: "tag",
    title: "Pricing Review",
    body: "Even large, sophisticated companies often fail to charge what they should. Are you?",
  },
  {
    icon: "gauge",
    title: "Capacity Performance vs. Staffing",
    body: "Are you properly staffed to support and grow your company?",
  },
  {
    icon: "handshake",
    title: "Sales Process Review",
    body: "Receive foundational instruction that CertainPath's original courses were built on.",
  },
  {
    icon: "wrench",
    title: "Production / Productivity Review",
    body: "Is your team as efficient as they should be?",
  },
  {
    icon: "package",
    title: "Material Management Review",
    body: "Add 2–3% to your bottom line by tightening your processes.",
  },
  {
    icon: "megaphone",
    title: "Marketing Performance Review",
    body: "Are you investing dollars or wasting dollars?",
  },
  {
    icon: "headset",
    title: "Call Center Performance Review",
    body: "Improve your call booking percentage 5–10%.",
  },
];

export const STEPS = [
  {
    title: "Your Advisor Comes to You",
    body: "A Strategic Business Advisor flies in and spends 2 days evaluating every facet of your operation, side by side with you.",
  },
  {
    title: "Get a Written Plan",
    body: "A plan of action with 3–5 focus areas and a step-by-step plan for hitting each target.",
  },
  {
    title: "Loop In Your Coach",
    body: "Findings go to your CertainPath Coach, adding another layer of accountability.",
  },
  {
    title: "Two Monthly 1:1s",
    body: "Your SOAR Advisor meets with you monthly for 2 months to keep you on track and answer questions.",
  },
  {
    title: "Repeat Quarterly",
    body: "Run the process again each quarter for as long as you like, until you build the company you envision.",
  },
];

export const FAQS: CpAccordionItem[] = [
  {
    title: "Who is SOAR for?",
    body: "CertainPath members who want to take their company to a higher level — more revenue, more profit, or both.",
  },
  {
    title: "Is SOAR included in my membership?",
    body: "SOAR is an add-on available at every membership stage: Build, Grow, Lead and Scale.",
  },
  {
    title: "What happens during the on-site visit?",
    body: "Your Strategic Business Advisor spends two days in your business — talking to your people, observing workflows and studying your financials across 10 review areas.",
  },
  {
    title: "What do I get after the visit?",
    body: "A written plan of action with 3–5 focus areas and step-by-step actions, shared with your CertainPath Coach, plus two monthly one-on-ones with your SOAR Advisor.",
  },
  {
    title: "Can I repeat SOAR?",
    body: "Yes. SOAR is designed as a quarterly program you can repeat for as long as you like.",
  },
  {
    title: "What if all spots are filled?",
    body: "Spots are limited. If the program is full when you apply, we'll let you know you're on the waitlist.",
  },
];
